export default __webpack_public_path__ + "static/media/arrow_right.4cf7fc25.svg";